import { Component, Input } from '@angular/core';

@Component({
  selector: 'echexpayment-tab',
  //templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.css'],
  template: `
        <div [hidden]="!show">
            <ng-content></ng-content>
        </div>
    `
})
export class TabComponent {

  @Input()
  tabTitle:string;
  show:boolean = false;

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/tab/tab.component.ts